<template>
  <div v-loading="loading">
    <div v-for="bXyWapHome in pageHome" :key="bXyWapHome.id">

      <!-- 轮播图start -->
      <el-carousel class="carouselBox" trigger="click" height="500px" v-if="bXyWapHome.ascription == 1">
        <el-carousel-item v-for="(item, index) in bXyWapHome.column" :key="index">
          <router-link  :to="`${item.url}`">
          <el-image :src="`${item.picimg}`" fit="fill" style="width: 100%; height: 500px" >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          </router-link>
        </el-carousel-item>
      </el-carousel>
      <!-- 轮播图end -->

      <!-- 通知轮播start -->
      <div class="shop_new" v-if="bXyWapHome.ascription == 13">
        <div class="sy_c">
          <div class="sy_gg">
            <div class="shop_new_logo">
              <img th:src="@{/portal/images/new1.png}" />
              <div class="shop_new_text">最新公告</div>
            </div>
            <div class="ranklist">
              <el-carousel direction="vertical" :interval="2000" class="notice_div" indicator-position="none">
                <el-carousel-item v-for="item in notice_list" :key="item">
                  <router-link :to="`siteHelpDetail?itemId=${item.articleId}`" :underline="false"
                    :title="item.articleTitle">{{ item.articleTitle }}</router-link>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="new_more">
              <el-button @click="$router.push('/siteHelp?articleId=2&categoryId=8')" type="danger" icon="el-icon-more"
                size="small" title="更多"></el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 通知轮播 end -->

      <!-- 热门分类层start -->
      <div class="w w1200" v-if="bXyWapHome.ascription == 13">
          <div class="sy_c">
            <div class="sy_gg">
              <div class="shop_new_logo">
                <img th:src="@{/portal/images/new1.png}" />
                <div class="shop_new_text">热门分类</div>
              </div>
            </div>
          </div>
        <el-row :gutter="20" style="margin: 0 0">
          <el-col class="channel-column" :span="5" v-for="(item, index) in list_hot_Category" :key="index + '_hot'"
            :style="
              'background:url(' +
              require('../../assets/images/channel_bg' + (index + 1) + '.jpg') +
              ') no-repeat;'
            ">
            <div class="column-title">
              <h3>{{ item.name }}</h3>
              <p>{{ item.remark }}</p>
            </div>
            <div class="column-img">
              <el-image :src="`${item.icon}`" fit="fill">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <router-link :to="`/goodsList?bxscId=${item.bxscId}&bxscName=${item.name}`" class="column-btn">去看看
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 热门分类层end -->

      <!--  一行三个图片 模板1105 开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 2">
        <div class="block onethreeImg1">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img alt="广告位置2" :src="bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img alt="广告位置3" :src="bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

    <!--  广告图 开始 -->
    <div class="wrap1 clearfix" v-if="bXyWapHome.ascription == 12">
      <div class="block el-image">
        <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
          <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
        </router-link>
      </div>
    </div>
    <!--  广告图 结束 -->

      <!--  一行三个图片 模板1111开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 8">
        <div class="block onethreeImg2">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img alt="广告位置2" :src="bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img alt="广告位置3" :src="bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

      <!-- 模板1 start 美丽人生--模板1110-->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 7">
        <h4 class="floor_title">
          <a href="javascript:;">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1110_标题'}}</a>
        </h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{
            bXyWapHome.column[1].name!=null?bXyWapHome.column[1].name:'模板1110_右标1'
          }}</router-link>
          <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
            {{bXyWapHome.column[2].name != null ? bXyWapHome.column[2].name:"模板1110_右标2"}}
          </router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_second">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <!-- :onerror="defaultImg" -->
              <img alt="广告图片"
                :src="bXyWapHome.column[3].picimg!=null?bXyWapHome.column[3].picimg:''" style="display: inline" />
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img alt="广告图片"
                :src="bXyWapHome.column[4].picimg!=null?bXyWapHome.column[4].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''"><img alt="广告图片"
                :src="bXyWapHome.column[5].picimg!=null?bXyWapHome.column[5].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img alt="广告图片"
                :src="bXyWapHome.column[6].picimg!=null?bXyWapHome.column[6].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''"><img alt="广告图片"
                :src="bXyWapHome.column[7].picimg!=null?bXyWapHome.column[7].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''"><img alt="广告图片"
                :src="bXyWapHome.column[8].picimg!=null?bXyWapHome.column[8].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="max_goods" :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''"><img alt="广告图片"
                :src="bXyWapHome.column[9].picimg!=null?bXyWapHome.column[9].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[10].picimg!=null?bXyWapHome.column[10].picimg:''"
                style="display: inline" />
            </router-link>
          </div>
        </div>
      </div>
      <!-- 模板1 end -->
      <!-- 限时秒杀 v-if="bXyWapHome.ascription==3"-->
      <!-- <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 3">
        <el-row :gutter="20">
          <el-col :span="5">
            <div class="grid-content">
              <el-image :src="kill_image">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-col>
          <el-col :span="19">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <div class="skill_act_pic">
                    <el-image
                      src="http://47.97.97.45/test/image.php/shop/data/upload/media/store/1003/image/20180710/1531209987736030.jpg"
                      class="bg">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="skill_act_name">
                    雅诗兰黛小棕瓶面部精华 特润修护肌透精华露30ml 修护
                  </div>
                  <div class="skill_act_price">
                    <span class="act_now_price"><i>¥</i> <span>89.90</span></span><span class="act_old_price"><i>¥</i>
                      <span>239.00</span></span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div> -->

      <!-- 拼团楼层 -->
      <!-- <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 4">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content-spell bg-purple">
              <div class="spell_goods_pic">
                <el-image
                  src="http://47.97.97.45/test/image.php/shop/data/upload/media/store/1003/image/20180710/1531209987736030.jpg"
                  class="bg">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="act_info">
                <p>距离本场结束</p>
                <p><span class="day">89</span><strong> 天</strong> <span class="hour">00</span><strong> 时</strong> <span
                    class="mini">58</span><strong> 分</strong> <span class="sec">21</span><strong> 秒</strong></p>
                <p class="buy_cart"></p>
              </div>
              <div class="pname">
                <p class="name">雅诗兰黛小棕瓶面部精华 特润修护肌透精华露30ml 修护 </p>
                <p class="price"><i>¥</i>49.90</p>
              </div>
              <div class="percentBar">
                <div class="barWrap"><b style="width: 50%;"></b></div>
                <div style="    margin-top: 2px;">
                  <p class="fl">限量3000件</p>
                  <p class="fr">剩余50%</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <!-- 模板1108 -->
      <div class="wrap1 floor_style_first clearfix" v-if="bXyWapHome.ascription == 5">
        <div class="mt fn-clear">
          <div class="floor_title">
            <router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1108_标题'}}</router-link>
          </div>
          <div class="floor_hotcat">
            <a href="">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '右侧标题'}}</a>
          </div>
        </div>
        <div class="mc fn-clear">
          <div class="floor_content">
            <div class="floor_banner">
               <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
                  <img
                    alt="广告图片" :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''"
                    style="display: inline-block;">
               </router-link>
            </div>
            <div class="floor_goods">
              <div class="block">
                <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
                  <img
                      alt="广告图片"
                      :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''"
                      style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''"><img
                    alt="广告图片"
                    :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''"
                    style="display: inline-block;"></router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''"><img
                    alt="广告图片"
                    :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''"
                    style="display: inline-block;"></router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img
                    alt="广告图片"
                    :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''"
                    style="display: inline-block;"></router-link>
              </div>
            </div>
            <div class="floor_cat">
              <div class="block">
                <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[8].picimg!=null? bXyWapHome.column[8].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[9].picimg!=null? bXyWapHome.column[9].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[10].picimg!=null? bXyWapHome.column[10].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 楼层模板1112 -->
      <div class="wrap1 floor_style_third clearfix" v-if="bXyWapHome.ascription == 9">
        <h4 class="floor_title"><router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1112_标题'}} </router-link></h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '模板1108_标题'}}</router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_third">
            <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
            <img alt="广告图片"
                :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img
                alt="广告图片1112"
                :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg:''">
            </router-link>
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg:''">
            </router-link>
            <router-link  class="last_item" :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg:''">
            </router-link>
            <router-link   :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg:''">
            </router-link>
             <router-link  class="last_item max_goods" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg:''">
             </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1113 -->
      <div class="wrap1 floor_style_fourth clearfix" v-if="bXyWapHome.ascription == 10">
        <h4 class="floor_title"><router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : '模板1113_标题'}}</router-link></h4>
        <div class="floor_hotcat">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : '右标题'}}</router-link>
        </div>
        <div class="floor_content">
          <div class="banner1">
              <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
                <img
                    alt="广告图片"
                    :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''"
                    style="display: inline;">
              </router-link>
          </div>
          <div class="banner2">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
            <div class="last_item" ><img
                alt="广告图片"
                :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''"></div>
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img
                alt="广告图片"
                :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <div class="last_item"><img
                  alt="广告图片"
                  :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''"></div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1114 -->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 11">
        <el-row :gutter="12">
          <el-col :span="4"  v-for="(item, index) in bXyWapHome.column" :key="index" style="width:19.8%">
            <router-link :to="item.url!=null?item.url:''">
            <div class="grid-content-1114 bg-purple">
              <div class="goods_pic_1114">
                <el-image :src="item.picimg" class="bg">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <!-- 模板2 start -->

      <!-- <div class="wrap1 floor_style_fourth clearfix"  v-if="bXyWapHome.ascription==4">
            <h4 class="floor_title">
              <a>{{bXyWapHome.name}}</a
              >
            </h4>
            <div class="floor_hotcat">
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=436"
                >蓝牙</a
              >
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=438"
                >腕机</a
              >
              <a
                href="https://www.xunyoutest.com/?ctl=Product&amp;met=detail&amp;typ=e&amp;product_id=440"
                >相机</a
              >
            </div>
            <div class="floor_content">
              <div class="banner1">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[0].id}`"
                  ><img
                   alt="广告图片"
                     :src="bXyWapHome.column[0].url"
                    style="display: inline"
                /></router-link>
              </div>
              <div class="banner2">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[1].id}`"
                  ><img
                   alt="广告图片"
                    :src="bXyWapHome.column[1].url"
                    style="display: inline"
                /></router-link>
              </div>
              <div class="floor_goods">
                <router-link
                   :to="`/goodsdetail?id=${bXyWapHome.column[2].id}`"
                  ><img
                    alt="广告图片"
                     :src="bXyWapHome.column[2].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  class="last_item"
                  :to="`/goodsdetail?id=${bXyWapHome.column[3].id}`"
                  ><img
                    alt="广告图片"
                     :src="bXyWapHome.column[3].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  :to="`/goodsdetail?id=${bXyWapHome.column[4].id}`"
                  ><img
                    alt="广告图片"
                    :src="bXyWapHome.column[4].url"
                    style="display: inline-block"
                /></router-link>
                <router-link
                  class="last_item"
                   :to="`/goodsdetail?id=${bXyWapHome.column[5].id}`"
                  ><img
                  alt="广告图片"
                    :src="bXyWapHome.column[5].url"
                    style="display: inline-block"
                /></router-link>
              </div>
            </div>
          </div> -->
      <!-- 模板2  end -->

      <!-- 模板3  start -->
      <!-- <div class="wrap1 floor_style_first clearfix" v-if="bXyWapHome.ascription==5">
            <div class="mt fn-clear">
              <div class="floor_title">
                <a>{{bXyWapHome.name}}</a>
              </div>
              <div class="floor_hotcat">
                <a
                  href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006&amp;page=2"
                  >品牌闪购</a
                >
                <a
                  href="https://www.xunyoutest.com/index.php?ctl=Product&amp;met=lists&amp;category_id=1006"
                  >今日疯抢</a
                >
                <div>{{bXyWapHome.column[0].id}}</div>
              </div>
            </div>
            <div class="mc fn-clear">
              <div class="floor_content">

                <div class="floor_banner">
                  <router-link
                    :to="`/goodsdetail?id=${bXyWapHome.column[0].id}`"
                    ><img
                     alt="广告图片"
                     :src="bXyWapHome.column[0].url"
                      style="display: inline"
                  /></router-link>
                </div>
                <div class="floor_goods">
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[1].id}`"
                      ><img
                        alt="广告图片"
                       :src="bXyWapHome.column[1].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[2].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[2].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[3].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[3].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[4].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[4].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                </div>
                <div class="floor_cat">
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[5].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[5].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[6].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[6].url"
                        style="display: inline"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[7].id}`"
                      ><img
                       alt="广告图片"
                        :src="bXyWapHome.column[7].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                  <div class="block">
                    <router-link
                      :to="`/goodsdetail?id=${bXyWapHome.column[8].id}`"
                      ><img
                        alt="广告图片"
                        :src="bXyWapHome.column[8].url"
                        style="display: inline-block"
                    /></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
      <!-- 模板3 end-->
    </div>
    <div class="w1200_container">
      <div class="clear"></div>
      <favoritGoods></favoritGoods>
    </div>
  </div>
</template>
<script type="text/javascript" src="../../assets/js/kuCity.js"></script>
<script>
  // import "../../assets/css/base.css";
  // import "@/assets/css/style.css";
  // import "../../assets/css/slide.css";
  import {
    swiperList,
    categoryHotList,
    noticeList,
    getPage
  } from "@/api/xunyou";
  import favoritGoods from "@/components/favoritGoods";
  export default {
    name: 'mainIndex',
    data() {
      return {
        defaultImg: `this.src='http://127.0.0.1/profile/upload/2021/02/24/dfb444a33aefe4ebc55982f3f2b570ca.jpg'`,//设置错误图片加载
        kill_image: "https://www.xunyoutest.com/shop_admin/static/src/default/images/pagepreview/1106_brand.png",
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        imgitems: [], //轮播图
        list_hot_Category: [], //热门分类
        notice_list: [],
        title: "添加",
        editForm: {
          deptId: "",
          deptName: "",
          deptNo: "",
          token: this.$store.getters.token,
        },
        // rules表单验证
        rules: {
          deptName: [{
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          }, ],
          deptNo: [{
            required: true,
            message: "请输入部门代码",
            trigger: "blur"
          }, ],
        },
        formInline: {
          page: 1,
          limit: 10,
          varLable: "",
          varName: "",
          token: this.$store.getters.token,
        },
        // 删除部门
        seletedata: {
          ids: "",
          token: this.$store.getters.token,
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10,
        },

        // 装修
        id: 1,
        pageHome: [],
      };
    },
    components: {
      favoritGoods
    },
    created() {
      this.searchSwiperList(); //轮播图方法
      this.searchCategoryHotList();
      this.searchNoticeList();
      this.getPageInfo();
    },
    updated() {
      this.open2();
    },
    methods: {


      //广告
      open2() {
        //查看是不是又广告位

        this.$notify.closeAll();
        var count = 0;
        this.pageHome.forEach((item) => {
          if (item.ascription == 12) {
            count = 1;
          }
        });
        if (count == 1) {
          // this.$notify({
          //   title: '提示',
          //   message: '这是一条不会自动关闭的消息',
          //   position: 'bottom-right',
          //   duration: 0
          // });
        }
      },
      // 轮播图查询
      searchSwiperList() {
        this.loading = true;
        swiperList()
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.imgitems = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            this.$message.error("轮播图加载失败，请稍后再试！");
          });
      },
      // 热门分类图查询
      searchCategoryHotList() {
        this.loading = true;
        categoryHotList()
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.list_hot_Category = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            this.$message.error("加载失败，请稍后再试！");
          });
      },
      // 通知查询
      searchNoticeList() {
        this.loading = true;
        var req = {
          articleType: 2,
        };
        noticeList(req)
          .then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.notice_list = res.rows;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.loading = false;
            this.$message.error("加载失败，请稍后再试！");
          });
      },

      /** ---------------装修接口 开始 ------------------- */
      // 查询接口
      getPageInfo() {
        this.loading = true;
        getPage({
            id: this.id
          })
          .then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.pageHome = res.data;
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("加载失败，请稍后再试！");
          });
      },
      // 页面数据处理
      // dealData(){
      // },
      /** ---------------装修接口 结束 ------------------- */
    },
  };

</script>

<style scoped lang="less">
  //秒杀
  .skill_act_pic {
    width: -webkit-fill-available;
    height: 177px;
    overflow: hidden;
    padding: 28px;
  }

  .skill_act_name {
    width: 166px;
    line-height: 30px;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 10px 28px;
  }

  .skill_act_price {
    width: 165px;
    height: 30px;
    margin: 10px 28px;
  }

  .skill_act_price .act_now_price {
    display: inline-block;
    width: 80px;
    text-align: center;
    color: #fff;
    line-height: 28px;
    height: 28px;
    border: 1px solid #c11045;
    background: #c11045;
  }

  .skill_act_price .act_old_price {
    display: inline-block;
    width: 80px;
    text-align: center;
    line-height: 28px;
    height: 28px;
    background: #fff;
    text-decoration: line-through;
    border: 1px solid #c11045;
    color: #8f8f8f;
  }

  //平团
  .grid-content-spell {
    border-radius: 4px;
    min-height: 423px;
  }

  .spell_goods_pic {
    width: -webkit-fill-available;
    height: 200px;
    overflow: hidden;
    padding: 28px;
  }

  .act_info {
    width: 100%;
    height: 60px;
    background: #c11045;
    // padding: 10px 0px;
    padding: 10px 10px;
    box-sizing: border-box;
    color: #FFF;
    position: relative;
    font-size: 12px;
    line-height: 18px;
  }

  .act_info span {
    display: inline-block;
    width: 18px;
    height: 18px;
    text-align: center;
    background: #FFF;
    border-radius: 5px;
    color: #c11045;
    line-height: 18px;
  }

  .act_info p {
    margin-bottom: 2px;
  }

  .act_info .buy_cart {
    position: absolute;
    width: 120px;
    height: 30px;
    right: 0px;
    top: 0px;
    background: url(../../assets/images/buy_cart.png);
    top: 15px;
  }

  .pname {
    width: 100%;
    height: 55px;
    margin-top: 10px;
    position: relative;
  }

  .pname .name {
    width: 185px;
    margin: 15px;
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    text-align: left;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #333;
  }

  .pname .price {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 18px;
    line-height: 28px;
    height: 28px;
    color: #c11045;
    font-weight: bold;
  }

  .percentBar {
    width: 250px;
    margin: 0px 15px;
  }

  .percentBar .barWrap {
    width: 100%;
    height: 8px;
    border: 6px;
    border: 1px solid #ffa9c3;
    border-radius: 8px;
    position: relative;
  }

  .percentBar .barWrap b {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #ffa9c3;
  }

  b,
  strong {
    font-weight: 700 !important;
  }

  //楼层模板1114
  .grid-content-1114 {
    border-radius: 4px;
    min-height: 460px;
  }

  .goods_pic_1114 {
    width: -webkit-fill-available;
    height: 460px;
    overflow: hidden;
  }

  //公用
  /deep/.el-image div.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #d3dce638;
    color: #909399;
    font-size: 40px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
  }

  .bg {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  //提示框
  /deep/.el-notification.right {
    right: 55px;
  }

  /deep/.el-notification {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 96%;
    padding: 14px 26px 14px 13px;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #EBEEF5;
    position: fixed;
    background-color: #FFF;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    -webkit-transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s;
    transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
    overflow: hidden;
  }

  // .left_bar {
  //     width: 230px;
  //     height: 336px;
  //     background-image: url(../images/index/skill.png);
  //     float: left;
  //     margin-right: 2px;
  //     position: relative;
  // }

  .carouselBox.el-carousel.el-carousel--horizontal {
    width: calc(100% - 40px);
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .bg-purple {
    // background: #d3dce638;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  }

  .grid-content {
    border-radius: 4px;
    min-height: 330px;
  }

  .el-col-5 {
    width: 20%;
  }

  /* 热门分类 start*/
  .column-title {
    text-align: center;
    color: #fff;
    min-height: 82px;
    overflow: hidden;
  }

  .channel-column {
    width: 230px;
    height: 330px;
    float: left;
    margin-right: 10px;
    position: relative;
    z-index: 1;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
  }

  .column-img {
    width: 155px;
    height: 155px;
    margin: 20px auto 0;
  }

  .column-btn {
    display: block;
    width: 140px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    border-radius: 20px;
    background-color: #fff;
    position: absolute;
    bottom: 17px;
    left: 46px;
    -webkit-transition: all 150ms ease-in-out;
    transition: all 150ms ease-in-out;
  }

  /* 热门分类 end*/
  /* 公告通知 start */
  .notice_div {
    height: 100%;
    line-height: 50px;
    font-size: 16px;
  }

  /deep/.notice_div .el-carousel__container {
    height: 100%;
  }

  /* 公告通知 end */

</style>



// WEBPACK FOOTER //
// src/views/dashboard/main.vue